/* tslint:disable */
/* eslint-disable */
/**
 * Spotnana API documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Different ways that client can call the openid token endpoint.
 * @export
 * @enum {string}
 */

export const ClientAuthenticationMethod = {
    Basic: 'CLIENT_SECRET_BASIC',
    Post: 'CLIENT_SECRET_POST'
} as const;

export type ClientAuthenticationMethod = typeof ClientAuthenticationMethod[keyof typeof ClientAuthenticationMethod];


